module.exports = __webpack_public_path__ + "img/module.5f1fb713.png";